import {
  ScmIntegrationsApi,
  scmIntegrationsApiRef,
  ScmAuth,
  scmAuthApiRef,
} from '@backstage/integration-react';
import {
  configApiRef,
  discoveryApiRef,
  gitlabAuthApiRef,
  identityApiRef
} from '@backstage/core-plugin-api';

import { EnvManagerApiRef } from './apis/envmanager/api.interface';
import { EnvManagerApiClient } from './apis/envmanager/api';
import { DatabaseApiRef } from './apis/database/api.interface';
import { DatabaseApiClient } from './apis/database/api';
import { ApplicationDeployApiRef } from './apis/application-deploy/api.interface';
import { ApplicationDeployApiClient } from './apis/application-deploy/api';
import { WorkloadApiRef } from './apis/workload/api.interface';
import { WorkloadApiClient } from './apis/workload/api';
import { gitlabRegistryApiRef } from './apis/registry-catalog/api.interface';
import { GitlabRegistryClient } from './apis/registry-catalog/api';
import { ApiBlueprint } from '@backstage/frontend-plugin-api';

const scmIntegrationsApi = ApiBlueprint.make({
  name: 'scm-integrations',
  params: defineParams =>
    defineParams({
      api: scmIntegrationsApiRef,
      deps: { configApi: configApiRef },
      factory: ({ configApi }) => ScmIntegrationsApi.fromConfig(configApi),
    }),
});

const scmAuthApi = ApiBlueprint.make({
  name: 'scm-auth',
  params: defineParams =>
    defineParams({
      api: scmAuthApiRef,
      deps: { gitlabAuthApi: gitlabAuthApiRef },
      factory: ({ gitlabAuthApi }) => ScmAuth.forGitlab(gitlabAuthApi),
    }),
});

const envManagerApi = ApiBlueprint.make({
  name: 'env-manager',
  params: defineParams =>
    defineParams({
      api: EnvManagerApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        identityApi: identityApiRef,
        scmAuthApi: scmAuthApiRef
      },
      factory: ({ discoveryApi, identityApi, scmAuthApi }) =>
        new EnvManagerApiClient({ discoveryApi, identityApi, scmAuthApi }),
    }),
});

const databaseApi = ApiBlueprint.make({
  name: 'database',
  params: defineParams =>
    defineParams({
      api: DatabaseApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        identityApi: identityApiRef,
        scmAuthApi: scmAuthApiRef
      },
      factory: ({ discoveryApi, identityApi, scmAuthApi }) =>
        new DatabaseApiClient({ discoveryApi, identityApi, scmAuthApi }),
    }),
});

const applicationDeployApi = ApiBlueprint.make({
  name: 'application-deploy',
  params: defineParams =>
    defineParams({
      api: ApplicationDeployApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        identityApi: identityApiRef,
        scmAuthApi: scmAuthApiRef
      },
      factory: ({ discoveryApi, identityApi, scmAuthApi }) =>
        new ApplicationDeployApiClient({ discoveryApi, identityApi, scmAuthApi }),
    }),
});

const workloadApi = ApiBlueprint.make({
  name: 'workload',
  params: defineParams =>
    defineParams({
      api: WorkloadApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        identityApi: identityApiRef,
        scmAuthApi: scmAuthApiRef
      },
      factory: ({ discoveryApi, identityApi, scmAuthApi }) =>
        new WorkloadApiClient({ discoveryApi, identityApi, scmAuthApi }),
    }),
});


const gitlabRegistryApi = ApiBlueprint.make({
  name: 'gitlab-registry',
  params: defineParams =>
    defineParams({
      api: gitlabRegistryApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        identityApi: identityApiRef
      },
      factory: ({ discoveryApi, identityApi }) =>
        new GitlabRegistryClient(discoveryApi, identityApi),
    }),
});

// Export all APIs
export default [
  scmIntegrationsApi,
  scmAuthApi,
  envManagerApi,
  databaseApi,
  applicationDeployApi,
  workloadApi,
  //visitsApi,
  gitlabRegistryApi,
];
